var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-table",
    {
      attrs: {
        data: _vm.firmas,
        bordered: false,
        narrowed: true,
        hoverable: true,
        loading: _vm.isLoading,
        focusable: true,
        sortable: "",
        "mobile-cards": true,
      },
      scopedSlots: _vm._u([
        {
          key: "empty",
          fn: function () {
            return [
              _c("div", { staticClass: "is-family-monospace" }, [
                _vm._v(
                  _vm._s(_vm.subunidad ? "La subunidad" : "El documento") +
                    " no ha sido firmado por ningún usuario"
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("b-table-column", {
        attrs: {
          field: "id",
          sortable: "",
          label: "Orden",
          width: "40",
          numeric: "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [_vm._v("\n    # " + _vm._s(props.row.id) + "\n  ")]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("b-table-column", {
        attrs: { label: "Nombre y Apellido" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                !_vm.isLoading && _vm.getUsuario(props.row.usuario_id)
                  ? _c("span", [
                      _c("i", { staticClass: "fas fa-user fa-fw" }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm
                              .getUsuario(props.row.usuario_id)
                              .apellido.toUpperCase()
                          ) +
                          ", " +
                          _vm._s(_vm.getUsuario(props.row.usuario_id).nombre) +
                          "\n    "
                      ),
                    ])
                  : _c("span", [
                      _c("i", { staticClass: "fas fa-sync fa-spin" }),
                      _vm._v(" Cargando...\n    "),
                    ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("b-table-column", {
        attrs: { label: "Email" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                !_vm.isLoading && _vm.getUsuario(props.row.usuario_id)
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "mailto:" +
                              _vm.getUsuario(props.row.usuario_id).email,
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.getUsuario(props.row.usuario_id).email)
                          ),
                        ]
                      ),
                    ])
                  : _c("span", [
                      _c("i", { staticClass: "fas fa-sync fa-spin" }),
                      _vm._v(" Cargando...\n    "),
                    ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("b-table-column", {
        attrs: { label: "Tipo de firma" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [_vm._v("\n    " + _vm._s(props.row.tipo) + "\n  ")]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("b-table-column", {
        attrs: {
          field: "created_at",
          label: "Date",
          sortable: "",
          centered: "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _vm._f("moment")(
                        new Date(props.row.created_at),
                        "DD/MM/YYYY"
                      )
                    ) +
                    "\n  "
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }